import React from 'react';
import colorVariables from '@densityco/ui/variables/colors.json';
import Chip, { ChipProps } from '../Chip';
import Tooltip from '../Tooltip';

import { CaptureStatus, CAPTURE_STATUS_TO_PRETTY_NAME } from '../../types/api';

const ColoredCaptureStatus: React.FunctionComponent<{
  size?: ChipProps['size'];
  captureStatus: CaptureStatus;
}> = ({ size, captureStatus }) => {
  const isInEndState = [
    // Regular captures finish the process in this state
    CaptureStatus.post_qa_score_complete,
    // Captures in MPI capture groups end the process in this state
    CaptureStatus.mpi_scored,
  ].includes(captureStatus);

  const isInFailedState = [CaptureStatus.failed, CaptureStatus.frozen].includes(captureStatus);


  // Determine the color of the chip component
  const color = isInFailedState ? '#fff' : colorVariables.gray700;
  let backgroundColor = colorVariables.blue100;
  if (isInEndState) {
    backgroundColor = colorVariables.green200;
  }
  if (isInFailedState) {
    backgroundColor = colorVariables.red400;
  }

  const captureMetadata = CAPTURE_STATUS_TO_PRETTY_NAME[captureStatus];
  if (!captureMetadata) {
    // This really shouldn't happen, but it's here to make typescript happy
    return (
      <Chip size={size} color={color} backgroundColor={backgroundColor}>
        {captureStatus}
      </Chip>
    );
  }

  const [prettyName, description] = captureMetadata;

  return (
    <Tooltip
      contents={description}
      target={
        <span style={{cursor: 'help'}} data-test-id={`capture-status-${captureStatus}`}>
          <Chip size={size} backgroundColor={backgroundColor} color={color}>
            {prettyName}
          </Chip>
        </span>
      }
    />
  );
};

export default ColoredCaptureStatus;
